module.exports = __webpack_public_path__ + "uz.svg?c55b50661bc142b184c21b1aa37207d0";